import { useMissionsStore } from '@/stores/missions-store';
import { EchoList } from './echo-list';
import { EchoDetail } from './echo-detail';

/** Echo panel router — shows mission list or detail based on store state */
export function EchoPanel(): React.JSX.Element {
  const selectedDetail = useMissionsStore((s) => s.selectedDetail);

  return selectedDetail ? <EchoDetail detail={selectedDetail} /> : <EchoList />;
}
